export enum PopupPosition {
    top = 'TOP',
    bottom = 'BOTTOM',
}
